import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import * as invoiceAdditionActions from '../../../redux/invoiceAdditions/actions';
import alertAndConfirmation from '../../../utils/AlertAndConfirmation';

import Spin from '../../../components/loading';

function DeleteInvoiceAddition(props) {
  const { loading, error, message, failed } = props;

  const remove = () => {
    props.actions.remove(props.id).then(() => {
      alertAndConfirmation({
        type: 'success',
        title: locales('titles.deletedSuccessfully'),
        text: ''
      });

      props.close(true);
    });
  };

  const close = e => {
    e.preventDefault();

    props.close();
  };

  return (
    <Modal size="xl" isOpen={props.isOpen}>
      <ModalHeader>
        <span className="modal-title">{locales('titles.delete.invoice.addition')}</span>
        <span
          title={locales('labels.close.modal')}
          className="modal-close"
          onClick={close}
          disabled={loading}
        >
          close
        </span>
      </ModalHeader>
      <ModalBody>
        <Spin spinning={loading}>
          <article>
            {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
            {failed && <div className="alert alert-danger">{message}</div>}
            <div className="row">
              <div className="col-12">
                {locales('messages.delete.invoice.addition.confirm', {
                  fieldName: props.title
                })}
              </div>
            </div>
          </article>
        </Spin>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-danger mx-1" onClick={remove} disabled={loading}>
          <i className="fal fa-trash mx-1" />
          {locales('labels.delete')}
        </button>
        <button className="btn btn-light mx-1" onClick={close} disabled={loading}>
          {locales('labels.cancel')}
        </button>
      </ModalFooter>
    </Modal>
  );
}

function mapStateToProps(state) {
  return {
    loading: state.invoiceAdditionsReducer.deleteInvoiceAdditionLoading,
    error: state.invoiceAdditionsReducer.deleteInvoiceAdditionError,
    failed: state.invoiceAdditionsReducer.deleteInvoiceAdditionFailed,
    message: state.invoiceAdditionsReducer.deleteInvoiceAdditionMessage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      remove: id => dispatch(invoiceAdditionActions.remove(id))
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteInvoiceAddition);
